<template>
<div class="bottom-footer flexc justify_center">
  <p>Copyright © 安陆市涢创投资开发有限公司 Rights Reserved</p>
  <p class="flexr justify_center">  <img src="@/assets/images/jgwab.png" /> <a href="http://beian.miit.gov.cn/" target="_blank">主体备案号： 鄂ICP备2025107417号</a><img style="margin-left: 20px;" src="@/assets/images/jgwab.png" /><a  href="http://beian.miit.gov.cn/" target="_blank">网站备案号： 鄂ICP备2025107417号-1</a>
  </p>
</div>
</template>

<script>
export default {
  name: "bottomFooter"
}
</script>

<style scoped lang="scss">
.bottom-footer{
  height: 102px;
  background: #012955;
  border-radius: 0px 0px 0px 0px;
  text-align: center;
  color: #fff;
  font-size: 14px;
  line-height: 1.5;
  letter-spacing: 1px;
  a{
    &:hover{
      color: #2C89F1;
    }

  }
  img{
    width: 17px;
    margin-right: 2px;
  }
}
</style>
